export const properties = [
    {
        id: 1,
        description: 'Finish-out Building',
        type: 'sale',
        lat: 32.43343924,
        lng: -97.1038205,
        address: '112 Second Street',
        neighborhood: 'Central Business District',
        zipCode: '76084',
        city: 'Venus',
        county: 'Johnson',
        state: 'Texas',
        saleCost: null,
        leaseCost: null,
        constructionSqft: null,
        acreage: null,
        landSqft: null,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['1a', '1b'],
    },
    {
        id: 2,
        description: 'Building for Retail Lease',
        type: 'lease',
        lat: 32.43337,
        lng: -97.10397,
        address: '116 Second Street',
        neighborhood: 'Central Business District',
        zipCode: '76084',
        city: 'Venus',
        county: 'Johnson',
        state: 'Texas',
        saleCost: null,
        leaseCost: null,
        constructionSqft: 2000,
        acreage: null,
        landSqft: null,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['2a', '2b'],
    },
    {
        id: 3,
        description: 'Medical / Office for Lease',
        type: 'lease',
        lat: 32.433003,
        lng: -97.10255,
        address: '206 S Main Street',
        neighborhood: 'Central Business District',
        zipCode: '76084',
        city: 'Venus',
        county: 'Johnson',
        state: 'Texas',
        saleCost: null,
        leaseCost: null,
        constructionSqft: 4800,
        acreage: 0.12,
        landSqft: 5100.88,
        rooms: 2,
        bathrooms: 2,
        stories: 2,
        ac: true,
        centralAir: true,
        photos: ['3a', '3b'],
    },
    {
        id: 4,
        description: 'Land for Sale',
        type: 'sale',
        lat: 32.4335,
        lng: -97.10274,
        address: '200 S Main Street',
        neighborhood: 'Central Business District',
        zipCode: '76084',
        city: 'Venus',
        county: 'Johnson',
        state: 'Texas',
        saleCost: '$220,000',
        leaseCost: null,
        constructionSqft: null,
        acreage: 0.35,
        landSqft: 15236.42,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['4a', '4b'],
    },
    {
        id: 5,
        description: 'Land for Sale — Highway Frontage',
        type: 'sale',
        lat: 32.43493,
        lng: -97.10592,
        address: '109 W US Highway 67',
        neighborhood: 'Highway',
        zipCode: '76084',
        city: 'Venus',
        county: 'Johnson',
        state: 'Texas',
        saleCost: '$1,300,000',
        leaseCost: null,
        constructionSqft: null,
        acreage: 2.83,
        landSqft: 123057,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['5a'],
    },
    {
        id: 6,
        description: 'Land for Sale — Highway Frontage',
        type: 'sale',
        lat: 32.43486,
        lng: -97.11112,
        address: '299 E US Highway 67',
        neighborhood: 'Highway',
        zipCode: '76084',
        city: 'Venus',
        county: 'Johnson',
        state: 'Texas',
        saleCost: null,
        leaseCost: null,
        constructionSqft: null,
        acreage: 9.609,
        landSqft: 430808.40,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['6a', '6b', '6c'],
    },
    {
        id: 7,
        description: 'Large Tract — Land for Sale',
        type: 'sale',
        lat: 32.435343,
        lng: -97.124815,
        address: '10816 County Road 501',
        neighborhood: 'Highway',
        zipCode: '76084',
        city: 'Venus',
        county: 'Johnson',
        state: 'Texas',
        saleCost: '$2,269,650',
        leaseCost: null,
        constructionSqft: null,
        acreage: 30.262,
        landSqft: 1318212.72,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['7a', '7b', '7c'],
    },
    {
        id: 8,
        description: 'Large Tract — Land for Sale',
        type: 'sale',
        lat: 32.43897,
        lng: -97.090398,
        address: '1115 E C.R. 109',
        neighborhood: 'County Road',
        zipCode: '76084',
        city: 'Venus',
        county: 'Johnson',
        state: 'Texas',
        saleCost: null,
        leaseCost: null,
        constructionSqft: null,
        acreage: 124,
        landSqft: 5401440,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['8a', '8b', '8c', '8d'],
    },
    {
        id: 9,
        description: 'Land for Sale — Ellis County',
        type: 'sale',
        lat: 32.444974,
        lng: -97.079555,
        address: 'E US Highway 67',
        neighborhood: 'Highway',
        zipCode: '76084',
        city: 'Venus',
        county: 'Ellis',
        state: 'Texas',
        saleCost: null,
        leaseCost: null,
        constructionSqft: null,
        acreage: 26.8951,
        landSqft: 1169829.27,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['9a', '9b', '9c', '9d', '9e'],
    },
    {
        id: 10,
        description: 'Land for Sale — Ellis County',
        type: 'sale',
        lat: 32.446579,
        lng: -97.075769,
        address: 'E US Highway 67',
        neighborhood: 'Highway',
        zipCode: '76084',
        city: 'Venus',
        county: 'Ellis',
        state: 'Texas',
        saleCost: null,
        leaseCost: null,
        constructionSqft: null,
        acreage: 43.297,
        landSqft: 1883246.31,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['10a', '10b', '10c'],
    },
    {
        id: 11,
        description: 'Land for Lease — Highway Frontage',
        type: 'lease',
        lat: 32.43731,
        lng: -97.09592,
        address: '501 E US Highway 67',
        neighborhood: 'Highway',
        zipCode: '76084',
        city: 'Venus',
        county: 'Johnson',
        state: 'Texas',
        saleCost: null,
        leaseCost: '$0.96 / sq. ft.',
        constructionSqft: null,
        acreage: 37,
        landSqft: 1611720,
        rooms: null,
        bathrooms: null,
        stories: null,
        photos: ['11a', '11b', '11c'],
    },
];
